export default "__VITE_ASSET__19e8c45c__"